﻿import { Dialog, Notify, Loading, QSpinnerGears } from 'quasar'
import alert from '@/common/dialogs/alert.vue';
import confirmation from '@/common/dialogs/confirmation.vue';
import prompt from '@/common/dialogs/prompt.vue';
import exception from '@/common/dialogs/exception.vue';
import validation from '@/common/dialogs/validation.vue';

class Dialogs {
    Alert(title, message, persistent, icon) {
        return Dialog.create({
            component: alert,
            componentProps: {
                title: title,
                message: message,
                icon: icon,
                persistent: persistent
            },
        });
    }

    Confirm(title, message, persistent, icon) {
        return Dialog.create({
            component: confirmation,
            componentProps: {
                title: title,
                message: message,
                icon: icon || 'delete',
                size: 'sm',
                persistent: persistent == undefined ? true : persistent
            },
        });
    }

    Prompt(title, message, size, icon) {
        return Dialog.create({
            component: prompt,
            componentProps: {
                title: title,
                message: message,
                icon: icon || 'keyboard',
                size: size
            },
        });
    }

    Open(component, props) {
        return Dialog.create({
            component: component,
            componentProps: props
        });
    }

    Error(err) {
        let e = err.data?.Errors || err.data || err;
        return Dialog.create({
            component: err.status == 400 ? validation : exception,
            componentProps: {
                data: e,
            }
        });
    }

    Validation(errors) {
        return Dialog.create({
            component: validation,
            componentProps: {
                data: errors,
            }
        });
    }

    async Loading(callback, notifyText) {
        Loading.show({
            spinner: QSpinnerGears
        });

        try {
            await callback();
            if (notifyText) this.Notify(notifyText);

        } catch (e) {
            this.Error(e);
        }

        Loading.hide();
    }

    Notify(msg, icon) {
        Notify.create({
            message: msg,
            color: 'accent',
            textColor: 'white',
            icon: icon || 'info',
            iconColor: 'white',
            position: 'top',
            timeout: 3000
        });
    }
}

export default new Dialogs();